import { NgxRolesService } from 'ngx-permissions';
import { AuthService } from './../../services/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService
  ) { }

  ngOnInit() {
    if (this.roleService.getRole('ROLE_ADMIN')) {
      this.router.navigate(['/client/list']);
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')
      || this.roleService.getRole('ROLE_CLIENT') ||
      this.roleService.getRole('ROLE_SUPER_CLIENT')) {
        
        if (this.roleService.getRole('ROLE_PACK_PRO')) {
          this.router.navigate(['/dashboard/dashboard-pro']);
        } else if (this.roleService.getRole('ROLE_PACK_ESSENTIEL')) {
          //this.router.navigate(['/dashboard/dashboard-essentiel']);
          this.router.navigate(['/dashboard/dashboard-geo']);
        } else {
          this.router.navigate(['/dashboard/dashboard-geo']);  // Changed from /bus/map
        }
        
      //window.alert (this.roleService.getRole('ROLE_PACK_PRO'));
    } else {
      this.router.navigate(['/logout']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts